import { InstallationStatus } from "@/config/constants";
import { 
  RouteGeometry, 
  LoadInstallationQueryResult 
} from "./supabase-helpers";
import type { Json } from "@/integrations/supabase/types";

// Filter types for loads list
export interface LoadFilters {
  date: Date | undefined;
  status: string;
  installerId: string;
}

export const DEFAULT_LOAD_FILTERS: LoadFilters = {
  date: undefined,
  status: "all",
  installerId: "all",
};

// Installer profile for dropdown
export interface InstallerProfile {
  id: string;
  first_name: string | null;
  last_name: string | null;
}

// Load list item with installer info
export interface LoadListItem {
  id: string;
  load_date: string;
  status: string;
  notes: string | null;
  total_distance_km: number | null;
  estimated_duration_min: number | null;
  route_geometry: RouteGeometry | Json | null;
  installer_id: string | null;
  installer: {
    id: string;
    first_name: string | null;
    last_name: string | null;
  } | null;
}

// Status dialog state for partial/skipped installations
export interface StatusDialogState {
  open: boolean;
  installationId: string;
  status: InstallationStatus;
}

// Re-export LoadInstallationQueryResult as LoadInstallation for backwards compatibility
export type LoadInstallation = LoadInstallationQueryResult;

// Map of load_id to installations
export type InstallationsMap = Record<string, LoadInstallation[]>;
